import { useContext, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

// icons
import { SvgGuest } from "assets/icons/js/SvgGuest";
import { SvgNavigationArrow } from "assets/icons/js/SvgNavigationArrow";
import { ReactComponent as PlusIcon } from "assets/icons/svg/add.svg";
import { ReactComponent as MinusIcon } from "assets/icons/svg/minus.svg";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// helpers
import { searchUrlGuest } from "helpers/url";

// style
import "./style.scss";

export const GuestPopup = ({ setGuestPopup }: any) => {
	// @ts-ignore
	const { query, setShowGuestPopup } = useContext(SearchPageDataInterface);

	const [searchParams, setSearchParams] = useSearchParams();

	const [data, setData] = useState({
		rooms: query?.get("rooms") > 1 ? query?.get("rooms") : 1,
		guests: query?.get("guests") > 1 ? query?.get("guests") : 1,
		pets: 0,
	});

	const { pathname } = useLocation();

	return (
		<div className="search__guest-container">
			<div className="search__guest__top_wrapper">
				<div className="guest-header">
					<SvgNavigationArrow
						onClick={() => {
							if (pathname.split("/")[1] !== "collection") {
								setShowGuestPopup(false);
							} else {
								setGuestPopup(false);
							}
						}}
					/>
				</div>
				<div className="guest__content">
					<h2>Add guests & room</h2>
					<h6>You can select multiple options</h6>
					<div className="select-guest-input">
						<SvgGuest />
						<span>{data.guests} Guests</span>
						<span>-</span>
						<span>{data.rooms} Room</span>
					</div>
					<div className="select-room-wrapper">
						<div className="guest-elements">
							<h3>Guests</h3>

							<div className="guest-counter">
								<button
									aria-label="minus"
									// @ts-ignore
									className={data.guests === 1 && "disable"}
									disabled={data.guests === 1}
									onClick={() => {
										if (data.guests > 1) {
											setData({
												...data,
												guests: +data.guests - 1,
											});
										}
									}}
								>
									<MinusIcon />
								</button>
								<span className="counter">{data.guests}</span>
								<button
									aria-label="plus"
									onClick={() => {
										setData({
											...data,
											guests: +data.guests + 1,
										});
									}}
								>
									<PlusIcon />
								</button>
							</div>
						</div>

						<div className="guest-elements">
							<h3>Rooms</h3>

							<div className="guest-counter">
								<button
									aria-label="minus"
									// @ts-ignore
									className={data.rooms === 1 && "disable"}
									disabled={data.rooms === 1}
									onClick={() => {
										if (data.rooms > 1)
											setData({
												...data,
												rooms: +data.rooms - 1,
											});
									}}
								>
									<MinusIcon />
								</button>
								<span className="counter">{data.rooms}</span>
								<button
									aria-label="plus"
									onClick={() => {
										setData({
											...data,
											rooms: +data.rooms + 1,
										});
									}}
								>
									<PlusIcon />
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="btn-wrapper">
				<button
					aria-label="clear"
					onClick={() => setData({ rooms: 1, guests: 1, pets: 0 })}
				>
					Clear
				</button>
				<button
					aria-label="save"
					className="next-btn"
					onClick={() => {
						if (pathname === "/search") {
							//@ts-ignore
							window.location.href = searchUrlGuest(query, data, "/search");
						}

						if (pathname.split("/")[1] === "villas") {
							//@ts-ignore
							window.location.href = searchUrlGuest(query, data, "villas");
						}
						if (pathname.split("/")[1] === "collection") {
							searchParams.set("guests", data.guests.toString());
							searchParams.set("rooms", data.rooms.toString());
							setSearchParams(searchParams);
							setGuestPopup(false);
						}
					}}
				>
					Save
				</button>
			</div>
		</div>
	);
};
